import { useEffect, useState } from "react";
import { Header, Loading } from "../components";
import Axios from "axios";
import { DataDb, DataBr, Hora } from "../components/Formatar";
import { Row, Col, Container, Button } from "react-bootstrap";
import { Bar } from "react-chartjs-2";

import { Chart as ChartJS, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(...registerables, ChartDataLabels);

const RelatorioMovimento = () => {
  const hoje = DataDb();

  const [dataInicio, setDataInicio] = useState(hoje);
  const [dataFim, setDataFim] = useState(hoje);
  const [linha, setLinha] = useState("353");

  const [normal, setNormal] = useState([]);
  const [embarcada, setEmbarcada] = useState([]);

  const [total, setTotal] = useState({});

  const [loading, setLoading] = useState(false);

  const buscaDados = () => {
    setLoading(true);

    const n = [];
    const e = [];

    let totalNormal = 0;
    let totalEmbarcada = 0;

    const url = `http://187.86.158.45:3010/api/bilhetes/relatorio/dhViagem/${dataInicio}/${dataFim}/todas/todas/${linha}/todas/todas/N/todas`;

    Axios.get(url).then((res) => {
      res.data.sort((a, b) => a.dhViagem.localeCompare(b.dhViagem));

      res.data.forEach((doc) => {
        const data = DataBr(doc.dhViagem);
        const hora = Hora(doc.dhViagem);

        if (doc.ambiente === "5") {
          const origemLinha = doc.origemLinha;

          if (origemLinha) {
            let i = e.findIndex(
              (a) => a.data === data && a.origemLinha === origemLinha
            );

            if (i >= 0) {
              if (e[i].horarios[hora] > 0) {
                e[i].horarios[hora]++;
              } else {
                e[i].horarios[hora] = 1;
              }
            } else {
              e.push({
                data: data,
                origemLinha: origemLinha,
                horarios: { [hora]: 1 },
              });
            }
          }

          totalEmbarcada++;
        } else {
          const origem = doc.origemLinha || doc.origem.toUpperCase();

          let i = n.findIndex(
            (a) =>
              (a.data === data && a.origem === origem) ||
              (a.data === data && a.origemLinha === origem)
          );

          if (i >= 0) {
            if (n[i].horarios[hora] > 0) {
              n[i].horarios[hora]++;
            } else {
              n[i].horarios[hora] = 1;
            }
          } else {
            n.push({
              data: data,
              origem: origem,
              horarios: { [hora]: 1 },
            });
          }

          totalNormal++;
        }
      });

      setNormal(n);
      setEmbarcada(e);
      setTotal({ normal: totalNormal, embarcada: totalEmbarcada });
      setLoading(false);
    });
  };

  useEffect(() => {
    buscaDados();
  }, []);

  return (
    <>
      <Header />

      {loading && <Loading />}

      <Container className="mt-4">
        <Row>
          <Col sm={3} className="mb-3">
            <input
              className="form-control"
              type="date"
              id="inicio"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
            />
          </Col>
          <Col sm={3} className="mb-3">
            <input
              className="form-control"
              type="date"
              id="fim"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
            />
          </Col>

          <Col sm={3} className="mb-3">
            <select
              className="form-select"
              aria-label="linha"
              value={linha}
              onChange={(e) => setLinha(e.target.value)}
            >
              <option value="353">Pelotas x Porto Alegre</option>
              <option value="271">Pelotas x Rio Grande</option>
              <option value="20">Pelotas x Rio Grande (S. Porto)</option>
              <option value="622">Pelotas x Canguçu</option>
              <option value="269">Pelotas x Piratini</option>
              <option value="261">Pelotas x Chui</option>
              <option value="271A">Pelotas x Cassino</option>
              <option value="408">Rio Grande x Chui</option>
              <option value="1636">Canguçu x Porto Alegre</option>
              <option value="2760">Canguçu x Piratini</option>
            </select>
          </Col>

          <Col sm={3}>
            <Button onClick={buscaDados} className="col-sm-12">
              Consultar
            </Button>
          </Col>
        </Row>

        {!loading && (
          <Row className="my-3 text-center">
            <div className="my-3">
              <h6>{`NORMAL: ${total.normal} - ESTRADA: ${
                total.embarcada
              } - TOTAL: ${total.normal + total.embarcada}`}</h6>
              <hr />
            </div>

            {normal.map((doc) => (
              <Col sm={6} className="mb-3">
                <h6>{`${doc.data} - ORIGEM: ${doc.origem} `}</h6>
                <Bar
                  datasetIdKey="id"
                  options={{
                    plugins: {
                      datalabels: {
                        display: true,
                        color: "gray",
                        formatter: Math.round,
                        anchor: "end",
                        align: "end",
                      },
                    },
                    borderColor: "#36a2eb",
                    backgroundColor: "#36a2eb",
                    scales: {
                      y: {
                        min: 0,
                        max: 70,
                      },
                    },
                  }}
                  plugins={[ChartDataLabels]}
                  data={{
                    labels: Object.keys(doc.horarios),
                    datasets: [
                      {
                        label: "Vendidas",
                        data: Object.values(doc.horarios),
                      },
                    ],
                  }}
                />
              </Col>
            ))}
            {embarcada.map((doc) => (
              <Col sm={6} className="mb-3">
                <h6>{`${doc.data} - ORIGEM: ${doc.origemLinha} - ESTRADA`}</h6>
                <Bar
                  datasetIdKey="id"
                  options={{
                    plugins: {
                      datalabels: {
                        display: true,
                        color: "gray",
                        formatter: Math.round,
                        anchor: "end",
                        align: "end",
                      },
                    },
                    borderColor: "#ff6384",
                    backgroundColor: "#ff6384",
                    scales: {
                      y: {
                        min: 0,
                        max: 70,
                      },
                    },
                  }}
                  plugins={[ChartDataLabels]}
                  data={{
                    labels: Object.keys(doc.horarios),
                    datasets: [
                      {
                        label: "Vendidas",
                        data: Object.values(doc.horarios),
                      },
                    ],
                  }}
                />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
};

export default RelatorioMovimento;
